export default __webpack_public_path__ + "static/media/435.096488d3.jpg";